"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Theme_1 = require("./Theme");
var Response_1 = require("./Response");
var Block_1 = require("./Block");
var includeTypes = ['blocks'];
var matchInclude = function (el) { return function (inc) { return inc.id === el.id && inc.type === el.type; }; };
var selectIncludes = function (d) { return function (el) {
    var i = d.included.find(matchInclude(el));
    return i;
}; };
var selectRelationship = function (d) { return function (k) {
    var i = d.data.relationships[k].data;
    return i;
}; };
var mapIncludesToData = function (d) { return function (k) {
    return selectRelationship(d)(k)
        .map(selectIncludes(d))
        .filter(function (a) { return a; });
}; };
/**
 * function to flatten an array
 * @param acc
 * @param cur
 */
var arrayFlatten = function (acc, cur) { return acc.concat(cur); };
var mapResponseToDataModel = function (d) {
    switch (d.type) {
        case Response_1.DataType.block:
            var b = new Block_1.Block(d);
            return b;
        default:
            return undefined;
    }
};
var transformModule = function (data) {
    var mod = data.data;
    var includes = includeTypes
        .map(mapIncludesToData(data))
        .reduce(arrayFlatten, [])
        .map(mapResponseToDataModel);
    var themeData = data.included.find(function (r) { return r.type === 'theme'; });
    var theme = new Theme_1.Theme(themeData);
    return new Module({
        id: mod.id,
        links: mod.links,
        data: includes,
        relationships: mod.relationships,
        attributes: mod.attributes,
        theme: theme,
    });
};
exports.CreateModuleEndpoint = function (opts) {
    var connection = opts.connection;
    return {
        get: function (ref) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, connection.get(ref).then(transformModule)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
    };
};
var Module = /** @class */ (function () {
    function Module(props) {
        this.id = props.id;
        this.variants = props.variants;
        this.data = props.data;
        this.links = props.links;
        this.relationships = props.relationships;
        this.name = props.attributes.name;
        this.createdAt = props.attributes.created_at;
        this.updatedAt = props.attributes.updated_at;
        this.public = props.attributes.public;
        this.description = props.attributes.description;
        this.rootBlockId = props.attributes.root_block_id;
        this.theme = props.theme;
    }
    return Module;
}());
exports.Module = Module;
